module App.Dashboard {
	export type TechStats = {
		zeroSoldMinutesCount: number,
		hasSoldMinutesCount: number,
		totalSoldMinutes: number,
		serviceRequestCount: number,
		totalCommissions: number,
		totalHours: string,
		plansNotConverted: number,
		plansConverted: number,
		existingPlans: number,
		currentlyActivePlans: number
	}

	export type Range = {
		name: string,
		start: Date,
		end: Date
	}
}